module.exports = __webpack_public_path__ + "img/slider_galery_2.026ad266.jpg";